import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './globals.css'

// Clear any stale ServiceWorker cache
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister()
      console.log('ServiceWorker unregistered:', registration)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
